import { BlastAtmosphere } from '../components/BlastAtmosphere'
import { Button } from '../components/Button'
import { Panel } from '../components/Panel'
import { PlayButton } from '../components/PlayButton'
import { ServerStatus } from '../components/ServerStatus'
import { config } from '../lib/config'

export function HomePage() {
  return (
    <>
      <main>
        <section className="hero hero--home">
          <div className="hero__noise" />
          <div className="hero__content">
            <p className="eyebrow">TNTWars competitiva · Java Edition</p>
            <h1>
              Il core è <span>instabile.</span>
              <br />
              Tu no.
            </h1>
            <p className="hero__lead">
              Cannoni, strategia e precisione in un&apos;arena dove ogni blocco
              conta. Entra nel network BlastCore e scala il ranking MMR reale.
            </p>
            <div className="hero__actions">
              <PlayButton />
              <Button to="/tntwars" variant="secondary">
                Scopri TNTWars
              </Button>
            </div>
            <div className="hero__status">
              <ServerStatus />
              <span className="technical-label">IP {config.serverIp}</span>
            </div>
          </div>
          <div className="hero-logo-stage" aria-hidden="true">
            <span className="hero-logo-stage__halo" />
            <span className="hero-logo-stage__orbit hero-logo-stage__orbit--outer" />
            <span className="hero-logo-stage__orbit hero-logo-stage__orbit--inner" />
            <span className="hero-logo-stage__flare" />
            <div className="hero-logo-stage__float">
              <img
                alt=""
                className="hero-logo-stage__image"
                decoding="async"
                fetchPriority="high"
                height="1254"
                src="/assets/blastcore-logo.png"
                width="1254"
              />
            </div>
            <span className="hero-logo-stage__readout hero-logo-stage__readout--top">
              Core online
            </span>
            <span className="hero-logo-stage__readout hero-logo-stage__readout--bottom">
              Detonation ready
            </span>
            <BlastAtmosphere variant="hero" />
          </div>
        </section>
        <div className="magma-separator" aria-hidden="true" />

        <section className="section section--features">
          <BlastAtmosphere variant="section" />
          <header className="section-heading">
            <p className="eyebrow">Protocollo di detonazione</p>
            <h2>Prepara. Mira. Devasta.</h2>
          </header>
          <div className="feature-grid">
            <Panel eyebrow="01 / Precisione">
              <h3>Costruisci il cannone</h3>
              <p>
                Gestisci risorse e redstone. L&apos;esecuzione tecnica decide
                quanto la strategia.
              </p>
            </Panel>
            <Panel eyebrow="02 / Controllo">
              <h3>Proteggi il core</h3>
              <p>
                Tre vite, barriere e un obiettivo: mantenere il tuo core in
                piedi più a lungo dell&apos;avversario.
              </p>
            </Panel>
            <Panel eyebrow="03 / Competizione">
              <h3>Scala il ranking</h3>
              <p>
                Ranked ELO-based, placement stagionali e 22 gradi competitivi
                fino a TNT Legend.
              </p>
            </Panel>
          </div>
        </section>

        <section className="section cta-strip">
          <BlastAtmosphere variant="subtle" />
          <div>
            <p className="eyebrow">Pronto all&apos;innesco?</p>
            <h2>Entra su BlastCore.</h2>
          </div>
          <PlayButton />
        </section>
      </main>
    </>
  )
}
